export interface AutoCompleteBlockingPolicy {
    configurationId: number;
}
